export default function normalizeText(text) {
  return text.trim().toLowerCase();
}
